//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.FaceSetOffsetList.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[0,"ApproxOption",1,0],[1,"FaceSets",0,"GeometricUtilities.FaceSetOffsetList",0],[0,"MaximumExcludedObjects",1,0],[0,"OutputOption",1,0],[0,"PartialOption",1,0],[1,"Radius",0,"Expression",0],[0,"RemoveProblemVerticesOption",1,0],[0,"StepOption",1,0],[0,"Tolerance",1,0]],[[["orientation_method"],"SetOrientationMethod",{},1,0],[[],"GetOrientationMethod",{R_:{orientation_method:''}},0,0],[["point"],"SetInteriorPosition",{},1,0],[[],"GetInteriorPosition",{R_:{point:''}},0,0],[["numErrorFaces"],"GetErrorFaces",{R_:{errorFaces:"Face[]"}},0,0]],[]];
SPLM.Features.OffsetSurfaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.OffsetSurfaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.OffsetSurfaceBuilder.OutputOptionType = Object.freeze({
    "OneFeatureForConnectedFaces" : "OneFeatureForConnectedFaces", "OneFeatureForEachFace" : "OneFeatureForEachFace", "OneFeatureForAllFaces" : "OneFeatureForAllFaces"});

SPLM.Features.OffsetSurfaceBuilder.OrientationMethodType = Object.freeze({
    "UseExistingNormals" : "UseExistingNormals", "SpecifyInteriorPosition" : "SpecifyInteriorPosition"});

export default SPLM;